export default "__VITE_ASSET__769c4a84__"